import { EnvBase } from "./env.base";

/**
 * See env.ts and env.base.ts for more information.
 */
class Env extends EnvBase {
  thirdParty: EnvBase["thirdParty"] = {};

  hostConfig: EnvBase["hostConfig"] = {
    stripe: {
      proxyHost: "",
      host: "NA",
      apiPath: "NA",
    },
    cloud: {
      proxyHost: "",
      host: "https://us-central1-citygolfclub-production.cloudfunctions.net/api_v2",
      apiPath: "",
      cloudConfig: {
        apiKey: "AIzaSyBJzJBtt6Hj5L51A44Doc73PShFgV6kAZQ",
        authDomain: "citygolfclub-production.firebaseapp.com",
        databaseURL: "https://citygolfclub-production.firebaseio.com",
        projectId: "citygolfclub-production",
        storageBucket: "citygolfclub-production.appspot.com",
        messagingSenderId: "264639526407",
        appId: "1:264639526407:web:a597781fa0e7df68831ca2",
        measurementId: "G-HW4HKBRPNQ",
      },
    },
  };

  // Live Stripe key
  stripeKey: string =
    "pk_live_51HFRE7C7JurdMxChONbT6Zm6HErehJ1lbd28fuCPfxDDU7ebJkqCSt1kp9wnC7ioUXYEz80oKGYoc9E8SvoZmJXH00E0LjdrAu";

  // Resources will come from the same domain and path as the app.
  // https://citygolfclub.co/picture.jpg
  baseStaticRoute = "";
}

export const ENV = new Env().init();
